import React, { useState } from "react";
import CustomButton from "../common/layout/CustomButton";
import { buildApiUrl, API_ENDPOINTS } from "../../config/api";
import { apiRequest } from "../../utils/apiUtils";
import PasswordStrengthChecklist from "./PasswordStrengthChecklist.jsx";

const ChangePasswordModal = ({ isOpen, onClose, onPasswordChanged }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [showPasswords, setShowPasswords] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones
    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ text: "Las contraseñas no coinciden", type: "error" });
      return;
    }

    setLoading(true);
    setMessage({ text: "", type: "" });

    try {
      await apiRequest(buildApiUrl(API_ENDPOINTS.changePassword), {
        method: "POST",
        body: JSON.stringify({
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
        }),
      });

      // Si llegamos aquí, fue exitoso
      setMessage({
        text: "Contraseña cambiada exitosamente",
        type: "success",
      });
      setTimeout(() => {
        onPasswordChanged();
        onClose();
      }, 1500);
    } catch (error) {
      console.error("Error:", error);
      setMessage({
        text: error.message || "Error de conexión",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content change-password-modal">
        <div className="modal-header">
          <h2>🔐 Cambiar Contraseña</h2>
          <p className="modal-subtitle">
            Por seguridad, debes cambiar tu contraseña temporal por una nueva.
          </p>
        </div>

        {message.text && (
          <div className={`message ${message.type}`}>{message.text}</div>
        )}

        <form onSubmit={handleSubmit} className="change-password-form">
          <div className="form-group">
            <label htmlFor="currentPassword">Contraseña Actual *</label>
            <div className="password-input-container">
              <input
                type={showPasswords ? "text" : "password"}
                id="currentPassword"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleInputChange}
                required
                className="form-input"
                placeholder="Ingresa tu contraseña actual"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">Nueva Contraseña *</label>
            <div className="password-input-container">
              <input
                type={showPasswords ? "text" : "password"}
                id="newPassword"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleInputChange}
                required
                className="form-input"
                placeholder="Mínimo 8 caracteres"
              />
            </div>
            <PasswordStrengthChecklist password={formData.newPassword} />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">
              Confirmar Nueva Contraseña *
            </label>
            <div className="password-input-container">
              <input
                type={showPasswords ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required
                className="form-input"
                placeholder="Repite la nueva contraseña"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={showPasswords}
                onChange={(e) => setShowPasswords(e.target.checked)}
              />
              Mostrar contraseñas
            </label>
          </div>

          <div className="modal-actions">
            <CustomButton type="submit" disabled={loading} className="primary">
              {loading ? "Cambiando..." : "Enviar"}
            </CustomButton>
          </div>
        </form>

        <div className="security-notice">
          <p>
            ⚠️ <strong>Importante:</strong> Esta acción no se puede deshacer.
            Asegúrate de recordar tu nueva contraseña.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
